<template>
  <DrawerHeader @close="emit('back-button-click')">
    Enter email address
  </DrawerHeader>
  <form
    class="flex flex-col space-y-6 px-4 pb-4"
    @submit="onSubmit"
  >
    <div class="text-center text-sm text-background-fg/50">
      A link to access your web portal will be emailed to
      this email address
    </div>
    <TextInputFormField
      name="emailAddress"
      type="email"
      update-on-input
    />
    <ActionButtonPrimary
      type="submit"
      :disabled="submitDisabled"
      class="self-center"
      :is-loading="isSubmitting"
      >Request access link</ActionButtonPrimary
    >
  </form>
</template>

<script setup lang="ts">
import { requestPortalLoginLink } from "@/services/requestPortalLoginLink"
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import { emailAddressSchema } from "@/forms/validation/stringFieldSchemas"

const emit = defineEmits<{
  (eventName: "email-sent", address: string): void
  (eventName: "back-button-click"): void
}>()

const formSchema = z.object({
  emailAddress: emailAddressSchema("Email is required"),
})

const { handleSubmit, meta, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    emailAddress: "",
  },
})

const submitDisabled = computed(() => !meta.value.valid)

const onSubmit = handleSubmit(async ({ emailAddress }) => {
  try {
    await requestPortalLoginLink(emailAddress)
    emit("email-sent", emailAddress)
  } catch {
    toast.error("Failed to request access link")
  }
})
</script>
